import { APICfg } from 'services/api/api'
import { upsellingParse, upsellingWrite } from '.'

const apiCfg: APICfg = {
  endpoint: 'virtualexperiencesupselling',
  parse: upsellingParse,
  write: upsellingWrite,
}

export default apiCfg
